import './SoundTopic.css';
import MultiGallery from './MultiGallery.js';

import MusicProductionThumb from './img/music-production-bg.jpg';
import IEDModaThumb from './img/ied-city-tales-01.jpg';
import GhostEmpireThumb from './img/empire-afterlife-01.jpg';
import BattimentiThumb from './img/battimenti.jpg';

const items = [
  
  {
    type: 'image',
    title: 'Music Production',
    description: 'A portfolio of original music productions, showcasing my range as a music producer.',
    linkClass: 'link',
    content: MusicProductionThumb,
    extras: {
      title: 'Go to the playlist',
      url: 'https://soundcloud.com/sesapo/sets/highlights'
    },
  },
  
  
  {
    type: 'image',
    title: 'Composer & Sound Designer',
    description: 'IED Moda - City Tales [2012]\nMusic composition and sound design for the fashion exhibition showcasing the work of the graduated students of IED (European Design Institute),\nheld during the latest edition of AltaRoma in Rome',
    linkClass: 'link',
    content: IEDModaThumb,
    extras: {
      title: 'Read the article',
      url: 'https://insideart.eu/2012/07/10/non-solo-moda/'
    },
  },
  
  {
    type: 'image',
    title: 'Composer & Sound Designer',
    description: 'Uncovering the after life of the Italian empire" by Charles Burdett - video-essay [2025]',
    linkClass: 'link',
    content: GhostEmpireThumb,
    extras: {
      title: 'Read the article',
      url: 'https://bsr.ac.uk/presentation-of-video-essay-uncovering-the-afterlife-of-the-italian-empire/'
    },
  },
  
  {
    type: 'youtube',
    title: 'Tracce a prescindere [LP]',
    description: 'An LP containing a selection of my tracks dateing back to 2010.',
    linkClass: 'youtube-video',
    content: 'https://www.youtube.com/watch?v=MYZwDnEewm4',
    extras: {
      title: 'Go to album',
      url: 'https://www.amazon.com/Tracce-Prescindere-Sesapo/dp/B003YZSF50'
    },
  },
  
  {
    type: 'youtube',
    title: 'Composer & Sound Designer',
    description: 'Created and implemented all audio elements, including music, sound effects, and ambient audio, for a range of iGaming products and marketing materials @ PlatinGaming.',
    linkClass: 'youtube-video',
    content: 'https://www.youtube.com/watch?v=uSRk9kwfcDI',
    extras: {
      title: '',
      url: ''
    },
  },
  
  // {
  //   type: 'youtube',
  //   title: 'Composer & Sound Designer',
  //   description: 'Created and implemented all audio elements, including music, sound effects, and ambient audio, for a range of iGaming products and marketing materials.',
  //   linkClass: 'youtube-video',
  //   content: 'https://www.youtube.com/watch?v=0wRwPZ22OAc',
  //   extras: {
  //     title: '',
  //     url: ''
  //   },
  // },
  
  {
    type: 'image',
    title: 'Sound artist',
    description: 'Battimenti.\nFrom the Exhibit "TACTILE EYES – HAPTIC VISUALITY"',
    linkClass: 'link',
    content: BattimentiThumb,
    extras: {
      title: 'Listen & Read the article',
      url: 'https://www.roots-routes.org/10425/'
    },
  },
  
  {
    type: 'youtube',
    title: 'Sonicrama - Synthesiser',
    description: 'In this video, I introduce Sonicrama, an audio synthesizer I designed.\n It provides a concise overview of its functionality.',
    linkClass: 'youtube-video',
    content: 'https://www.youtube.com/watch?v=nooy0Ri98K0',
    extras: {
      title: 'Go to product page',
      url: 'https://acusmagic.com/product/sonicrama/'
    },
  },
  
];


function SoundTopic({ 
acceptedCookieCategories = { essential: true, analytics: false, marketing: false, externalMedia: false },
onUpdateCookiePreferences = () => {} 
})
{
  return (
    
    <div id="sound-topic-container">
   
      <div id="description-container">
      <span className="title">
      
      </span>
      <span className="content">
      Music Composing and Sound Design for<br/>
      Games | Video | Installations<br/>
      <span style={{fontSize:'1.8rem'}}>Developing audio software @ <a href="https://acusmagic.com/" style={{color:"var(--global-color-05)", textDecoration:"underline dotted"}}> AcusMagic</a> </span> <br/>
      <span className="content-small">Sound Design | Foley | SFX | Audio Programming</span><br/>
      
      </span>
      </div>
    <MultiGallery 
    items={items} 
    acceptedCookieCategories={acceptedCookieCategories} 
    onUpdateCookiePreferences={onUpdateCookiePreferences} 
    />
    
    <h3> MUSIC </h3>
    <iframe width="100%" height={400} scrolling="no" frameBorder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1625897662&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true" /><div style={{fontSize: '10px', color: '#cccccc', lineBreak: 'anywhere', wordBreak: 'normal', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', fontFamily: 'Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif', fontWeight: 100}}><a href="https://soundcloud.com/sesapo" title="Sesapo" target="_blank" style={{color: '#cccccc', textDecoration: 'none'}}>Sesapo</a> · <a href="https://soundcloud.com/sesapo/sets/highlights" title="Highlights" target="_blank" style={{color: '#cccccc', textDecoration: 'none'}}>Highlights</a></div>
    
     </div>
  );    
}


export default SoundTopic;